import * as actions from './preloader.actions'

const initialState = {
  preloaded: {},
  preloadedItemsCount: 0,
  toPreloadItemsCount: 0,
}

const actionsMap = {
  [actions.PRELOAD_START]: (state, action) => {
    const { toPreload } = action.data

    return {
      ...state,
      toPreloadItemsCount: Object.keys(toPreload).length,
      preloadedItemsCount: 0,
    }
  },

  [actions.PRELOAD_PROGRESS]: (state, action) => {
    const { assetId, url } = action.data

    return {
      ...state,
      preloaded: {
        ...state.preloaded,
        [assetId]: `${url}`,
      },
      preloadedItemsCount: state.preloadedItemsCount + 1,
    }
  },
}

/* eslint require-jsdoc: 0 */
export function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type]
  return fn ? fn(state, action) : state
}
